// src/components/UI/CountUp.jsx
import { useEffect, useRef, useState } from "react";
import "./countUp.css";

const reduceMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

// Muestra `value` contando desde el valor anterior (0 la primera vez).
export default function CountUp({ value, decimals = 0, suffix = "", duration = 800 }) {
  const target = Number(value) || 0;
  const [shown, setShown] = useState(reduceMotion() ? target : 0);
  const fromRef = useRef(shown);

  useEffect(() => {
    if (reduceMotion()) {
      setShown(target);
      fromRef.current = target;
      return undefined;
    }
    const from = fromRef.current;
    const start = performance.now();
    let frame;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
      const current = from + (target - from) * eased;
      setShown(current);
      fromRef.current = current;
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, duration]);

  // El número animado es solo visual; los lectores de pantalla reciben el valor final
  // (si no, una región aria-live anunciaría cada cuadro de la animación).
  return (
    <span className="count-up">
      <span aria-hidden="true">
        {shown.toFixed(decimals)}
        {suffix}
      </span>
      <span className="count-up__sr">
        {target.toFixed(decimals)}
        {suffix}
      </span>
    </span>
  );
}
